// src/styles/GlobalStyle.js
import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  /* Importar fuentes desde Google Fonts */
  @import url('https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700;900&family=Lora:wght@400;500;600;700&display=swap');

  /* --- AHORA (SIMPLE Y COMPATIBLE CON TAILWIND) --- */
  /*
    Dejamos que Tailwind se encargue de casi todo a través de su 'preflight' y las clases de utilidad.
    Solo mantenemos lo absolutamente necesario que Tailwind no maneja por defecto.
  */
  body {
    /* Opcional: Podemos definir aquí las fuentes por defecto si es necesario */
    /* Pero como ya están en tailwind.config.js, es mejor aplicarlas con clases como 'font-body' o 'font-heading' */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  /*
    Los estilos de selección y scrollbar son opcionales pero bonitos.
    Los alineamos con los colores de la marca definidos en el theme.
  */
  ::selection {
    background-color: ${({ theme }) => theme.colors.primary}; /* sfs-blue */
    color: white;
  }

  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  ::-webkit-scrollbar-track {
    background: #E8EDF2; /* neutral-200 */
  }

  ::-webkit-scrollbar-thumb {
    background: #829AB1; /* neutral-400 */
    border-radius: 9999px;
    
    &:hover {
      background: #486581; /* neutral-500 */
    }
  }
`;

export default GlobalStyle;
